export const ApiEndpoints = {
	PRODUCTS: "/requests/zoho/get-products",
	CREATE_GROUPED_PRODUCT: "/requests/zoho/create-grouped-product",
	CREATE_PRODUCT: "/requests/zoho/create-product",
	/* Both take their id as a query parameter — the request router matches
	   /requests/:tenant/:endpoint and nothing after it. */
	UPDATE_PRODUCT: "/requests/zoho/update-product",
	UPDATE_GROUPED_PRODUCT: "/requests/zoho/update-grouped-product",
	ALL_PRODUCTS: "/requests/zoho/get-all-products",
	GET_USERS: "/users/list",
	ROLES: "/users/roles",
	ASSIGN_SCOPES: "/users/asign-scope",
	UNASSIGN_SCOPES: "/users/unasign-scope",
	SCOPES: "/users/scopes",
	ADD_ADMIN_USER: "/users/add",
	PROFILES: "/users/profiles",
	HANDOFF: "/users/handoff",
	REDEEM_HANDOFF: "/users/handoff/redeem",
	UPDATE_PRODUCT_IMAGES: "/zoho/images",
	PRODUCTS_DETAILS: "/requests/zoho/get-product-detail",
	CATEGORIES: "/requests/zoho/get-formated-cat",
	GET_BRANDS: "/requests/zoho/get-formated-brand",
	ADD_LOCAL_CATEGORIES: "/requests/zoho/categories?platform=local",
	UPDATE_CATEGORIES: "/requests/zoho/update-categories",
	UPDATE_BRAND: "/requests/zoho/update-brands",
	ADD_LOCAL_BRANDS: "/requests/zoho/brands?platform=zoho",
	GET_VENDORS: "/requests/zoho/get-vendors",
	GET_VENDOR_DETAILS: "/requests/zoho/get-customer-details",
	GET_VENDOR: "/requests/zoho/get-vendor",
	UPDATE_VENDOR: "/requests/zoho/update-zoho-customer",
	CREATE_VENDOR: "/requests/zoho/create-zoho-customer",
	GET_CUSTOMER: "/requests/zoho/get-customer",
	GET_CURRENCIES: "/requests/startButton/exchange",
	SOURCING_CATEGORIES: "/sourcing-categories",
	SOURCING_CATEGORIES_PUBLIC: "/sourcing-categories/public",

	SOURCING_REQUESTS_ADMIN: "/custom-sourcing/admin/all",
	SOURCING_REQUEST_STATUS: (id) => `/custom-sourcing/admin/${id}/status`,
	BACKORDERS: "/custom-sourcing/backorders",
	BACKORDER_STATUS: (id) => `/custom-sourcing/backorders/${id}/status`,
	BACKORDER_SUMMARY: "/custom-sourcing/backorders/summary",
	BACKORDER_PRODUCTS: "/custom-sourcing/backorders/products",
	BACKORDER_PRODUCT: (itemId) => `/custom-sourcing/backorders/products/${itemId}`,

	TAGS: "/categories/tags",
	CATEGORY_TAGS: "/categories/category-tags",
};
